import { ConsoleLogger, LevelLogger, MemoryLogger, TagLogger, TeeLogger, UnveilLogger } from '../helpers/logger';
export class LogService {
    userConfig;
    memory;
    root;
    constructor() {
        this.userConfig = window['UserConfig'];
        let logger;
        const loggers = [];
        logger = new ConsoleLogger();
        logger = new UnveilLogger(logger);
        if (this.userConfig.CONSOLE_LOG_LEVEL !== 'debug') {
            logger = new LevelLogger(logger, this.userConfig.CONSOLE_LOG_LEVEL);
        }
        loggers.push(logger);
        logger = this.memory = new MemoryLogger(this.userConfig.REPORT_LOG_LIMIT);
        if (this.userConfig.REPORT_LOG_LEVEL !== 'debug') {
            logger = new LevelLogger(logger, this.userConfig.REPORT_LOG_LEVEL);
        }
        loggers.push(logger);
        this.root = new TeeLogger(loggers);
        this.setupUncaughtExceptionHandling();
    }
    getLogger(tag, style, level) {
        let styledTag;
        if (style !== undefined) {
            styledTag = `%c[${tag}]`;
        }
        else {
            styledTag = `[${tag}]`;
        }
        styledTag = styledTag.padStart(this.userConfig.LOG_TAG_PADDING + styledTag.length - tag.length);
        let logger;
        if (style !== undefined) {
            logger = new TagLogger(this.root, styledTag, style);
        }
        else {
            logger = new TagLogger(this.root, styledTag);
        }
        if (level !== undefined) {
            logger = new LevelLogger(logger, level);
        }
        return logger;
    }
    setupUncaughtExceptionHandling() {
        const logger = this.getLogger('UncaughtException');
        window.addEventListener('error', (e) => {
            const data = [];
            data.push(`Unhandled exception (w): ${e.message}\n`);
            data.push((e.error && e.error.stack) ? e.error.stack : e.error);
            logger.error(...data);
            e.stopPropagation();
            e.preventDefault();
            return true;
        });
        window.addEventListener('unhandledrejection', (e) => {
            logger.error('Unhandled promise rejection:', (e.reason && e.reason.stack) ? e.reason.stack : e.reason);
            e.stopPropagation();
            e.preventDefault();
            return true;
        });
    }
}
